import { Navigate, useLocation } from 'react-router-dom'
import React from 'react'

import { AppPath } from '@/enums/AppPath'

interface PrivateRouteProps {
  element: JSX.Element
  isAuthenticated: boolean
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element, isAuthenticated }) => {
  const location = useLocation()

  if (!isAuthenticated) {
    // Save the full URL (path + search) so user can return after login
    sessionStorage.setItem('returnUrl', location.pathname + location.search)

    return <Navigate to={`/${AppPath.Users}/sign-in`} />
  }

  return element
}

export default PrivateRoute
